var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 345.18755539924535,
    y: 345.18755539924535,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    d: "m49.2,65.9l-18.3,-0.1c-1,0 -2,-0.4 -2.7,-1.1l-13,-13c-0.7,-0.7 -1.1,-1.7 -1.1,-2.7l-0.1,-18.3c0,-1 0.4,-2 1.1,-2.7l12.9,-12.9c0.7,-0.7 1.7,-1.1 2.7,-1.1l18.3,0.1c1,0 2,0.4 2.7,1.1l13,13c0.7,0.7 1.1,1.7 1.1,2.7l0.1,18.3c0,1 -0.4,2 -1.1,2.7l-12.9,12.9c-0.7,0.7 -1.7,1.1 -2.7,1.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    r: 12.2,
    cy: 40,
    cx: 40
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    r: 7.3,
    cy: 40,
    cx: 40
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.e54d129144e8155543e495a20dc009b8.svg";
export { ForwardRef as ReactComponent };